import { render } from "./MembersWalletLogs.vue?vue&type=template&id=8b7751ea&scoped=true"
import script from "./MembersWalletLogs.vue?vue&type=script&lang=js"
export * from "./MembersWalletLogs.vue?vue&type=script&lang=js"

import "./MembersWalletLogs.vue?vue&type=style&index=0&id=8b7751ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7751ea"]])

export default __exports__